export const formOptions = {
  SELECT: "select",
  NUMBER: "number",
  TEXT: "text",
  DISABLED: "disabled",
  SELECT_WITH_FULL_DATA: "selectWithFullData",
};
